 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"components/ui/arCoreKitWarning.vue":"components/ui/arCoreKitWarning.vue","components/ui/arWarning.vue":"components/ui/arWarning.vue","components/ui/audio.vue":"components/ui/audio.vue","components/ui/colormode.vue":"components/ui/colormode.vue","components/ui/fontsize.vue":"components/ui/fontsize.vue","components/ui/keypad.vue":"components/ui/keypad.vue","components/ui/language.vue":"components/ui/language.vue","components/ui/map.vue":"components/ui/map.vue","dayjs/locale/af":"dayjs/locale/af","dayjs/locale/ar":"dayjs/locale/ar","dayjs/locale/ar-dz":"dayjs/locale/ar-dz","dayjs/locale/ar-kw":"dayjs/locale/ar-kw","dayjs/locale/ar-ly":"dayjs/locale/ar-ly","dayjs/locale/ar-ma":"dayjs/locale/ar-ma","dayjs/locale/ar-sa":"dayjs/locale/ar-sa","dayjs/locale/ar-tn":"dayjs/locale/ar-tn","dayjs/locale/az":"dayjs/locale/az","dayjs/locale/be":"dayjs/locale/be","dayjs/locale/bg":"dayjs/locale/bg","dayjs/locale/bm":"dayjs/locale/bm","dayjs/locale/bn":"dayjs/locale/bn","dayjs/locale/bo":"dayjs/locale/bo","dayjs/locale/br":"dayjs/locale/br","dayjs/locale/bs":"dayjs/locale/bs","dayjs/locale/ca":"dayjs/locale/ca","dayjs/locale/cs":"dayjs/locale/cs","dayjs/locale/cv":"dayjs/locale/cv","dayjs/locale/cy":"dayjs/locale/cy","dayjs/locale/da":"dayjs/locale/da","dayjs/locale/de":"dayjs/locale/de","dayjs/locale/de-at":"dayjs/locale/de-at","dayjs/locale/de-ch":"dayjs/locale/de-ch","dayjs/locale/dv":"dayjs/locale/dv","dayjs/locale/el":"dayjs/locale/el","dayjs/locale/en":"dayjs/locale/en","dayjs/locale/en-SG":"dayjs/locale/en-SG","dayjs/locale/en-au":"dayjs/locale/en-au","dayjs/locale/en-ca":"dayjs/locale/en-ca","dayjs/locale/en-gb":"dayjs/locale/en-gb","dayjs/locale/en-ie":"dayjs/locale/en-ie","dayjs/locale/en-il":"dayjs/locale/en-il","dayjs/locale/en-nz":"dayjs/locale/en-nz","dayjs/locale/eo":"dayjs/locale/eo","dayjs/locale/es":"dayjs/locale/es","dayjs/locale/es-do":"dayjs/locale/es-do","dayjs/locale/es-us":"dayjs/locale/es-us","dayjs/locale/et":"dayjs/locale/et","dayjs/locale/eu":"dayjs/locale/eu","dayjs/locale/fa":"dayjs/locale/fa","dayjs/locale/fi":"dayjs/locale/fi","dayjs/locale/fo":"dayjs/locale/fo","dayjs/locale/fr":"dayjs/locale/fr","dayjs/locale/fr-ca":"dayjs/locale/fr-ca","dayjs/locale/fr-ch":"dayjs/locale/fr-ch","dayjs/locale/fy":"dayjs/locale/fy","dayjs/locale/ga":"dayjs/locale/ga","dayjs/locale/gd":"dayjs/locale/gd","dayjs/locale/gl":"dayjs/locale/gl","dayjs/locale/gom-latn":"dayjs/locale/gom-latn","dayjs/locale/gu":"dayjs/locale/gu","dayjs/locale/he":"dayjs/locale/he","dayjs/locale/hi":"dayjs/locale/hi","dayjs/locale/hr":"dayjs/locale/hr","dayjs/locale/hu":"dayjs/locale/hu","dayjs/locale/hy-am":"dayjs/locale/hy-am","dayjs/locale/id":"dayjs/locale/id","dayjs/locale/is":"dayjs/locale/is","dayjs/locale/it":"dayjs/locale/it","dayjs/locale/it-ch":"dayjs/locale/it-ch","dayjs/locale/ja":"dayjs/locale/ja","dayjs/locale/jv":"dayjs/locale/jv","dayjs/locale/ka":"dayjs/locale/ka","dayjs/locale/kk":"dayjs/locale/kk","dayjs/locale/km":"dayjs/locale/km","dayjs/locale/kn":"dayjs/locale/kn","dayjs/locale/ko":"dayjs/locale/ko","dayjs/locale/ku":"dayjs/locale/ku","dayjs/locale/ky":"dayjs/locale/ky","dayjs/locale/lb":"dayjs/locale/lb","dayjs/locale/lo":"dayjs/locale/lo","dayjs/locale/lt":"dayjs/locale/lt","dayjs/locale/lv":"dayjs/locale/lv","dayjs/locale/me":"dayjs/locale/me","dayjs/locale/mi":"dayjs/locale/mi","dayjs/locale/mk":"dayjs/locale/mk","dayjs/locale/ml":"dayjs/locale/ml","dayjs/locale/mn":"dayjs/locale/mn","dayjs/locale/mr":"dayjs/locale/mr","dayjs/locale/ms":"dayjs/locale/ms","dayjs/locale/ms-my":"dayjs/locale/ms-my","dayjs/locale/mt":"dayjs/locale/mt","dayjs/locale/my":"dayjs/locale/my","dayjs/locale/nb":"dayjs/locale/nb","dayjs/locale/ne":"dayjs/locale/ne","dayjs/locale/nl":"dayjs/locale/nl","dayjs/locale/nl-be":"dayjs/locale/nl-be","dayjs/locale/nn":"dayjs/locale/nn","dayjs/locale/oc-lnc":"dayjs/locale/oc-lnc","dayjs/locale/pa-in":"dayjs/locale/pa-in","dayjs/locale/pl":"dayjs/locale/pl","dayjs/locale/pt":"dayjs/locale/pt","dayjs/locale/pt-br":"dayjs/locale/pt-br","dayjs/locale/ro":"dayjs/locale/ro","dayjs/locale/ru":"dayjs/locale/ru","dayjs/locale/sd":"dayjs/locale/sd","dayjs/locale/se":"dayjs/locale/se","dayjs/locale/si":"dayjs/locale/si","dayjs/locale/sk":"dayjs/locale/sk","dayjs/locale/sl":"dayjs/locale/sl","dayjs/locale/sq":"dayjs/locale/sq","dayjs/locale/sr":"dayjs/locale/sr","dayjs/locale/sr-cyrl":"dayjs/locale/sr-cyrl","dayjs/locale/ss":"dayjs/locale/ss","dayjs/locale/sv":"dayjs/locale/sv","dayjs/locale/sw":"dayjs/locale/sw","dayjs/locale/ta":"dayjs/locale/ta","dayjs/locale/te":"dayjs/locale/te","dayjs/locale/tet":"dayjs/locale/tet","dayjs/locale/tg":"dayjs/locale/tg","dayjs/locale/th":"dayjs/locale/th","dayjs/locale/tl-ph":"dayjs/locale/tl-ph","dayjs/locale/tlh":"dayjs/locale/tlh","dayjs/locale/tr":"dayjs/locale/tr","dayjs/locale/tzl":"dayjs/locale/tzl","dayjs/locale/tzm":"dayjs/locale/tzm","dayjs/locale/tzm-latn":"dayjs/locale/tzm-latn","dayjs/locale/ug-cn":"dayjs/locale/ug-cn","dayjs/locale/uk":"dayjs/locale/uk","dayjs/locale/ur":"dayjs/locale/ur","dayjs/locale/uz":"dayjs/locale/uz","dayjs/locale/uz-latn":"dayjs/locale/uz-latn","dayjs/locale/vi":"dayjs/locale/vi","dayjs/locale/x-pseudo":"dayjs/locale/x-pseudo","dayjs/locale/yo":"dayjs/locale/yo","dayjs/locale/zh-cn":"dayjs/locale/zh-cn","dayjs/locale/zh-hk":"dayjs/locale/zh-hk","dayjs/locale/zh-tw":"dayjs/locale/zh-tw","tools/developmentHelpers":"tools/developmentHelpers","tools/mqtt":"tools/mqtt","leaflet-distortableimage":"leaflet-distortableimage","leaflet-polylinedecorator":"leaflet-polylinedecorator","leaflet-toolbar":"leaflet-toolbar"}[chunkId]||chunkId) + "." + {"chunk-2d0aa1f5":"654eae0c","chunk-2d0ac92e":"f5d670be","chunk-2d0af8d8":"9b790b3c","chunk-2d0bce08":"ec33966b","chunk-2d0c4638":"f2d3deab","chunk-2d0c7d25":"b96da7c5","chunk-2d0d604d":"77b66d3c","chunk-2d22579b":"01c71bed","chunk-2d226749":"2ddfe53d","components/ui/arCoreKitWarning.vue":"9b740fee","components/ui/arWarning.vue":"14a40f52","components/ui/audio.vue":"ff63d73b","components/ui/colormode.vue":"7905a14e","components/ui/fontsize.vue":"1ffc5562","components/ui/keypad.vue":"95bd575c","components/ui/language.vue":"e09e9bec","components/ui/map.vue":"1522a533","dayjs/locale/af":"0877a89d","dayjs/locale/ar":"8f8cc0f2","dayjs/locale/ar-dz":"8d54978d","dayjs/locale/ar-kw":"0bc3f2ae","dayjs/locale/ar-ly":"1b5cfb07","dayjs/locale/ar-ma":"6b221ab1","dayjs/locale/ar-sa":"83767f54","dayjs/locale/ar-tn":"e72270df","dayjs/locale/az":"04833145","dayjs/locale/be":"69739b21","dayjs/locale/bg":"363aff1a","dayjs/locale/bm":"e5540c18","dayjs/locale/bn":"d112d0b9","dayjs/locale/bo":"ac2b9ad6","dayjs/locale/br":"a98aaa31","dayjs/locale/bs":"220f5c30","dayjs/locale/ca":"c9005d26","dayjs/locale/cs":"3b64e652","dayjs/locale/cv":"a307e2b3","dayjs/locale/cy":"948e0145","dayjs/locale/da":"811329c7","dayjs/locale/de":"b90982e3","dayjs/locale/de-at":"b9dcf0e8","dayjs/locale/de-ch":"3b05c5b3","dayjs/locale/dv":"ffd5a8f4","dayjs/locale/el":"37624bd1","dayjs/locale/en":"8fa19a1b","dayjs/locale/en-SG":"5c3844b4","dayjs/locale/en-au":"066f5acc","dayjs/locale/en-ca":"573e9731","dayjs/locale/en-gb":"702379fa","dayjs/locale/en-ie":"7698ae0f","dayjs/locale/en-il":"9be0dac0","dayjs/locale/en-nz":"1d9cc486","dayjs/locale/eo":"503669cc","dayjs/locale/es":"2b1ddb66","dayjs/locale/es-do":"6e76fc79","dayjs/locale/es-us":"a0f4ffcb","dayjs/locale/et":"d95916c4","dayjs/locale/eu":"0ca865ca","dayjs/locale/fa":"04bbc72e","dayjs/locale/fi":"4050c1ed","dayjs/locale/fo":"32ead8cc","dayjs/locale/fr":"6ca9c905","dayjs/locale/fr-ca":"062d96cc","dayjs/locale/fr-ch":"e3388a5f","dayjs/locale/fy":"da284e58","dayjs/locale/ga":"9be83a3f","dayjs/locale/gd":"f4ee9c35","dayjs/locale/gl":"6c24138c","dayjs/locale/gom-latn":"e24a0f06","dayjs/locale/gu":"78ed1d3b","dayjs/locale/he":"60ef424e","dayjs/locale/hi":"3c588213","dayjs/locale/hr":"f6173e14","dayjs/locale/hu":"1b291f31","dayjs/locale/hy-am":"c7a2343c","dayjs/locale/id":"05639ec3","dayjs/locale/is":"504ec729","dayjs/locale/it":"758eb2e0","dayjs/locale/it-ch":"2fd1ab9b","dayjs/locale/ja":"4624f5b2","dayjs/locale/jv":"1bead0ef","dayjs/locale/ka":"308822ec","dayjs/locale/kk":"67687e3a","dayjs/locale/km":"a26571f0","dayjs/locale/kn":"bbbc886b","dayjs/locale/ko":"7b9fcc64","dayjs/locale/ku":"08f071ab","dayjs/locale/ky":"93052207","dayjs/locale/lb":"de78563a","dayjs/locale/lo":"191d2b45","dayjs/locale/lt":"75f33109","dayjs/locale/lv":"1dfdaa20","dayjs/locale/me":"8d2b478f","dayjs/locale/mi":"4ff5c399","dayjs/locale/mk":"c2f7cd2f","dayjs/locale/ml":"3e36bf36","dayjs/locale/mn":"a69bc928","dayjs/locale/mr":"8b3195a5","dayjs/locale/ms":"6676c3a8","dayjs/locale/ms-my":"90475bfe","dayjs/locale/mt":"38481222","dayjs/locale/my":"94dc92c3","dayjs/locale/nb":"f8097809","dayjs/locale/ne":"07d020f2","dayjs/locale/nl":"2c494bbd","dayjs/locale/nl-be":"0e7d1805","dayjs/locale/nn":"86c22b6b","dayjs/locale/oc-lnc":"e58f02c8","dayjs/locale/pa-in":"80edc524","dayjs/locale/pl":"d19b9498","dayjs/locale/pt":"8aca23de","dayjs/locale/pt-br":"89dd274f","dayjs/locale/ro":"800bcc53","dayjs/locale/ru":"81a5bab6","dayjs/locale/sd":"fdcdbf07","dayjs/locale/se":"1fadb453","dayjs/locale/si":"e630921a","dayjs/locale/sk":"359f5614","dayjs/locale/sl":"eab8a679","dayjs/locale/sq":"d9ece811","dayjs/locale/sr":"fdc3d967","dayjs/locale/sr-cyrl":"f87a3462","dayjs/locale/ss":"5670f166","dayjs/locale/sv":"85ee88c1","dayjs/locale/sw":"810b5a16","dayjs/locale/ta":"f6011311","dayjs/locale/te":"0f5bb6df","dayjs/locale/tet":"bb8841d9","dayjs/locale/tg":"ccb3844b","dayjs/locale/th":"2cfb5c3e","dayjs/locale/tl-ph":"483d7f00","dayjs/locale/tlh":"45e99fc6","dayjs/locale/tr":"0348dfee","dayjs/locale/tzl":"623a8915","dayjs/locale/tzm":"fbd097d5","dayjs/locale/tzm-latn":"20d6fa8a","dayjs/locale/ug-cn":"c4567d11","dayjs/locale/uk":"15d4bc6b","dayjs/locale/ur":"0be4192e","dayjs/locale/uz":"2fd92061","dayjs/locale/uz-latn":"655e244a","dayjs/locale/vi":"3470cab6","dayjs/locale/x-pseudo":"59b984d6","dayjs/locale/yo":"0514b527","dayjs/locale/zh-cn":"2a9a2099","dayjs/locale/zh-hk":"9d5a8e6c","dayjs/locale/zh-tw":"bfe0eefd","tools/developmentHelpers":"8ddf697b","tools/mqtt":"cade7fa7","leaflet-distortableimage":"100eb5fa","leaflet-polylinedecorator":"7a5b508e","leaflet-toolbar":"b915e118"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
